export type BillingCheckoutReturnStatus =
  | 'none'
  | 'setup-success'
  | 'legacy-success-pending'
  | 'redirect-setup';

function searchParams(search: string): URLSearchParams {
  return new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
}

export function isSetupBillingCheckoutSuccess({
  pathname,
  search,
}: {
  pathname: string;
  search: string;
}): boolean {
  return pathname === '/setup' && searchParams(search).get('billing') === 'success';
}

export function isLegacyBillingCheckoutSuccess(search: string): boolean {
  return searchParams(search).get('status') === 'success';
}

export function checkoutReturnStatus({
  pathname,
  search,
  billingActive,
}: {
  pathname: string;
  search: string;
  billingActive: boolean;
}): BillingCheckoutReturnStatus {
  if (isSetupBillingCheckoutSuccess({ pathname, search })) return 'setup-success';
  if (pathname !== '/billing' || !isLegacyBillingCheckoutSuccess(search)) return 'none';
  return billingActive ? 'redirect-setup' : 'legacy-success-pending';
}

export function shouldPollBillingCheckoutReturn(state: BillingCheckoutReturnStatus): boolean {
  return state === 'legacy-success-pending';
}

export function shouldShowCheckoutSyncNotice(state: BillingCheckoutReturnStatus): boolean {
  return state === 'legacy-success-pending' || state === 'redirect-setup';
}
